<template>
  <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M19.6 2H16.4C15.5 2 14.8 2.7 14.8 3.6V14.8H3.6C2.7 14.8 2 15.5 2 16.4V19.6C2 20.5 2.7 21.2 3.6 21.2H14.8V32.4C14.8 33.3 15.5 34 16.4 34H19.6C20.5 34 21.2 33.3 21.2 32.4V21.2H32.4C33.3 21.2 34 20.5 34 19.6V16.4C34 15.5 33.3 14.8 32.4 14.8H21.2V3.6C21.2 2.7 20.5 2 19.6 2Z"
      fill="#212121"
    />
  </svg>
</template>
